<template>
  <div class="ts-list-box">
    <Header pageTitle="图书商城" />
    <div class="ts-search">
      <van-field
        v-model="insertString.queryValue"
        center
        clearable
        left-icon="search"
        placeholder="搜索"
      >
        <template #left-icon>
          <img
            class="ts-search-icon"
            src="@/assets/img/mobile-img/search-icon.png"
            alt=""
          />
        </template>
        <template #button>
          <van-button
            class="ts-search-btn"
            size="small"
            type="info"
            @click="toSearch"
            >搜索</van-button
          >
        </template>
      </van-field>
    </div>
    <div v-show="loading" style="text-align: center">
      <van-loading />
    </div>
    <div class="list" v-show="!loading">
      <vueWaterfallEasy
        ref="waterfall"
        v-show="articleList.length"
        class="list-box"
        :mobileGap="20"
        :imgsArr="articleList"
        :reachBottomDistance="80"
        @scrollReachBottom="onLoad"
      >
        <template slot-scope="props">
          <TsItem
            ref="waterfallItem"
            class="ts-item"
            :title="props.value.title"
            :cover="props.value.albumPics.split(',')[0]"
            :price="props.value.goodsPrice"
            @click.native="toDetail(props.value.id)"
          />
        </template>
      </vueWaterfallEasy>
      <noneList noneType="tsList" v-show="articleList.length === 0" />
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import TsItem from "@/views/mobileView/components/listItem/tsItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
import { Field, Button } from "vant";
import vueWaterfallEasy from "vue-waterfall-easy";
export default {
  name: "BookMall",
  components: {
    Header,
    TsItem,
    "van-field": Field,
    "van-button": Button,
    noneList,
    vueWaterfallEasy,
  },
  data() {
    return {
      insertString: {
        esField: "all",
        queryValue: "",
      },
      params: {
        pageNo: 0,
        pageSize: 20,
        beginDateTime: "",
        queryParam: {
          configMap: {
            must: [
              {
                esField: "goodsTypeId",
                queryValue: "1",
              },
            ],
          },
        },
      },
      articleList: [],
      loading: false,
      finished: false,
      error: false,
      columnHeights: [0, 0],
    };
  },
  created() {
    this.loading = true;
    this.onLoad();
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 搜索加载列表
    toSearch() {
      this.$refs.waterfall.reset();
      this.loading = true;
      this.params.pageNo = 1;
      this.articleList = [];
      this.getList();
    },
    // 获取列表
    async getList() {
      if (this.params.pageNo == 1) {
        this.params.beginDateTime = Number(new Date());
      }
      if (this.insertString.queryValue !== "") {
        this.params.queryParam.configMap.must[1] = this.insertString;
      } else {
        this.params.queryParam.configMap.must.splice(1, 1);
      }
      const resp = await this.$apis.searchServe.getEsTsBgList(this.params);
      if (resp.resultCode == 200) {
        if (resp.data.list.length) {
          this.articleList.push(...resp.data.list);
        } else {
          this.$refs.waterfall.waterfallOver();
        }
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push("/bookDetails?id=" + id);
    },
  },
};
</script>

<style scoped lang="scss">
.ts-list-box {
  position: relative;
  // padding-top: calc(constant(safe-area-inset-top) + 105px) !important;
  // padding-top: calc(env(safe-area-inset-top) + 105px) !important;
  height: 100vh;
  background-color: #f5f5f5;
  .ts-search {
    position: fixed;
    top: 44px;
    left: 0;
    width: 100%;
    height: 59px;
    background: #f5f5f5;
    z-index: 999;
    &::v-deep .van-cell {
      margin: 12px auto;
      padding: 3px 3px 3px 12px;
      width: 351px;
      border-radius: 18px;
      line-height: normal;
      .van-field__left-icon {
        margin-right: 10px;
        .ts-search-icon {
          margin-top: 5px;
          width: 15px;
          height: 15px;
        }
      }
      .ts-search-btn {
        width: 60px;
        height: 30px;
        border-radius: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .list {
    position: fixed;
    top: 105px;
    left: 0;
    width: 100%;
    height: calc(100% - 120px);
    .list-box {
      &::v-deep .loading {
        .dot {
          background-color: #747474 !important;
          width: 6px !important;
          height: 6px !important;
        }
      }
      &::v-deep .vue-waterfall-easy {
        .img-box {
          padding-top: 5px !important;
          padding-bottom: 5px !important;
          .img-inner-box {
            box-shadow: none;
            .ts-item-cover {
              height: 136px;
            }
          }
        }
      }
    }
  }
}
</style>
